import React from 'react';
import PropTypes from 'prop-types';
import SelectParkingForm from './select-parking-form';
import { PRODUCT_TYPE_PARKING } from '../../../general/js/basket/constants';
import ProductsHelper from './products-helper';
import TicketBuilderAside from './ticket-builder-aside';
import CheckoutButton from './checkout-button';
import { ROUTE_PARKING } from './constants';
import BasketDialogBoxContentBody from '../../../general/js/basket/basket-dialog-box-content-body';
import ConfirmationModal from '../../sso/components/common/utility/ConfirmationModal';

export default class SelectParkingPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isReadyToPay: this.getParkingList().some((parking) => parking.quantity > 0),
            focusCheckout: false,
            showModal: false
        };

        this.onSelectParkingQuantity = this.onSelectParkingQuantity.bind(this);
        this.toggleConfirmationModal = this.toggleConfirmationModal.bind(this);
        this.toggleCloseModal = this.toggleCloseModal.bind(this);
    }

    toggleConfirmationModal() {
        this.props.showDialogBox ? this.setState({ showModal: true }) : this.setState({ showModal: false });
    }

    onConfirmationModal(mc, onContinue) {
        this.toggleConfirmationModal();

        if (!this.props.showDialogBox)
            this.onCheckout(mc, onContinue)
    }

    toggleCloseModal() {
        this.setState({ showModal: false });
    }

    onCheckout(mc, onContinue) {
        this.props.onStartCheckout(mc);
        this.triggerContinue(onContinue, mc ? 'Pay with Mastercard' : 'Pay');
    }

    onClearParkingSelection() {
        const parkingList = this.getParkingList();
        const paramsList = parkingList.map((parking) =>
            Object.assign({}, {
                type: parking.type,
                tag: parking.tag
            }));

        this.props.onClearSelection(paramsList);
    }

    triggerContinue(onContinue, actionCaption) {
        onContinue(actionCaption, ROUTE_PARKING);
    }

    onRejectParkingClick(onContinue) {
        this.triggerContinue(onContinue, 'I don\'t need parking');
        this.onClearParkingSelection();
        this.setState({ isReadyToPay: true, focusCheckout: true });
    }

    onSelectParkingQuantity(...args) {
        this.props.onApplyProductsQuantity(...args);
        this.setState({ isReadyToPay: true, focusCheckout: false });
    }

    getParkingList() {
        return ProductsHelper.getProductsList(
            this.props.productGroupsList,
            this.props.basket.productGroups,
            (product) => product.type === PRODUCT_TYPE_PARKING
        );
    }

    // set focus for a11y reason
    checkoutRef(checkoutBtn) {
        if (checkoutBtn && this.state.focusCheckout) {
            setTimeout(() => {
                checkoutBtn.focus();
            }, 0);
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="ticket-builder__main">
                    <SelectParkingForm
                        dictionary={this.props.dictionary}
                        productGroupsList={this.props.productGroupsList}
                        currentScenario={this.props.currentScenario}
                        parkingList={this.getParkingList()}
                        onApplyProductsQuantity={this.onSelectParkingQuantity}
                        onClearSelection={() => this.onClearParkingSelection()}
                    />
                </div>
                <div className="ticket-builder__aside">

                    <TicketBuilderAside
                        productGroupsList={this.props.productGroupsList}
                        basket={this.props.basket}
                        onToggleBasketMobile={this.props.onToggleBasketMobile}
                        basketUrl={this.props.basketUrl}
                        renderControls={(onContinue) => (
                            this.state.isReadyToPay ?
                                <div className="ticket-builder__pay-controls">
                                    <CheckoutButton
                                        onStartCheckout={(mc) => this.onConfirmationModal(mc, onContinue)}
                                        checkoutBtnRef={this.checkoutRef.bind(this)}
                                    />
                                    <div className="throttle">
                                        <span>We are experiencing high volumes of traffic at the minute. Please try again.</span>
                                    </div>
                                    <ConfirmationModal
                                        isOpen={this.state.showModal}
                                        inputText={"Pay"}
                                        onModalClose={this.toggleCloseModal}
                                        onApproveClick={(mc) => this.onCheckout(mc, onContinue)}
                                        isApproveDanger={false}
                                        isApproveButtonDisabled={false}
                                        onCancelClick={this.toggleCloseModal}
                                        isCancelButtonDisabled={true}
                                        masterCardDialogBoxBanner={this.props.dialogBoxBanner}
                                    >
                                        <BasketDialogBoxContentBody
                                            basketDialogBoxTitle={this.props.dialogBoxTitle}
                                            basketDialogBoxMessage={this.props.dialogBoxMessage}
                                            basketDialogBoxLogo={this.props.dialogBoxLogo}>
                                        </BasketDialogBoxContentBody>
                                    </ConfirmationModal>
                                </div> :
                                <div className="ticket-builder__parking-controls">
                                    <button
                                        className="button button--primary ticket-builder__button"
                                        onClick={() => this.onRejectParkingClick(onContinue)}>
                                        <span className="button-content">
                                            <span>I don&rsquo;t need parking</span>
                                        </span>
                                    </button>
                                </div>
                        )}
                    />
                </div>
            </React.Fragment>
        );
    }
}

SelectParkingPage.propTypes = {
    dictionary: PropTypes.object.isRequired,
    basket: PropTypes.object,
    productGroupsList: PropTypes.array,
    categoriesList: PropTypes.array,
    currentScenario: PropTypes.string.isRequired,
    onApplyProductsQuantity: PropTypes.func,
    onClearSelection: PropTypes.func,
    onToggleBasketMobile: PropTypes.func,
    onStartCheckout: PropTypes.func,
    dialogBoxTitle: PropTypes.string,
    dialogBoxMessage: PropTypes.string,
    dialogBoxLogo: PropTypes.string,
    showDialogBox: PropTypes.bool
};
